import React from "react";
// import {Button as MTLButton, Stack} from "@mui/material";
// import {Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import {Button as MTLButton, Paper, Stack} from "@mui/material";
import {Button} from "../../components/FormZero/Button/Button";
import {get_number_of_trays_per_cart, isFlaggedNumberOfCarts} from "../CommonInfo";
import { DataGrid } from "@mui/x-data-grid";
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import { DataGridPro, DataGridProProps } from "@mui/x-data-grid-pro";
import moment from "moment";
import { IDeliveryHeader } from "../../interfaces/Logistics/IDeliveryHeader";
import CheckIcon from '@mui/icons-material/FactCheck';
import CloseIcon from '@mui/icons-material/CloseRounded';


export function OrdersDialog(props : any) {
    const {
        cellValues,
    } = props;

    console.log("CELL VALUES", cellValues);

    const [open, setOpen] = React.useState(false);
    const columns : any = [
        { field: 'brokerDeliveryID', headerName: 'Delivery #', width: 200 },
        // {field: 'CustomerName', headerName: 'Customer Name', width: 200},
        { field: 'soldToName', headerName: 'Customer Name', width: 200 },
        { field: 'shipToCity', headerName: 'City', width: 200 },
        { field: 'shipToState', headerName: 'State', width: 200 },
        // {field: 'Location', headerName: 'City', width: 150},
        // {field: 'State', headerName: 'State', width: 110},
        {
            field: "number_of_items", headerName: "# of Items", width: 150,
            valueGetter: (cellParams: { row: { deliveryItems: string | any[] | null | undefined; }; }) => (cellParams.row.deliveryItems !== null && cellParams.row.deliveryItems !== undefined) ? cellParams.row.deliveryItems.length : 0
        },
        {
            field: 'number_of_trays', headerName: '# of Trays', width: 200,
            valueGetter: (cellParams: { row: { deliveryItems: any[] | undefined; }; }) => {
                if (cellParams.row.deliveryItems === undefined) return 0;
                let list = cellParams.row.deliveryItems.map((item: { orderedQuantity: any; }) => item.orderedQuantity);
                return list.reduce((t: string, s: string) => parseInt(t) + parseInt(s), 0);
            }
        },
        {
            field: 'number_of_carts', headerName: '# of Carts', width: 200,
            renderCell: (cellValues: { row: { deliveryItems: any[] | undefined; }; }) => {
                let totalFilled = 0;
                let isOneFlagged = false;
                if (cellValues.row.deliveryItems !== undefined) {
                    totalFilled += cellValues.row.deliveryItems.reduce((t: number, item: { orderedQuantity: any; brokerMaterialNumber?: any; }) => {
                        if (isFlaggedNumberOfCarts(item)) {
                            isOneFlagged = true;
                        }
                        return t + get_number_of_trays_per_cart(item, item.orderedQuantity);
                    }, 0);
                }
                let cartCount = Math.ceil(totalFilled);
                return (
                    <>
                        <span style={{ color: isOneFlagged ? "#9C27B0" : "black" }}>{cartCount}</span>
                    </>
                );
            }
        }
    ]

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function DetailPanelContent({ row: rowProp }: { row: IDeliveryHeader }) {
        let deliveryItems = rowProp.deliveryItems != null ? rowProp.deliveryItems : [];
        return (
            <Stack
                sx={{ py: 2, height: '100%', boxSizing: 'border-box' }}
                direction="column"
            >
                <Paper sx={{ flex: 1, p: 1 }}>
                    <Stack direction="column" spacing={1} sx={{ height: 1 }}>
                        <DataGridPro
                            density="compact"
                            checkboxSelection={true}
                            columns={[
                                {
                                    field: 'brokerMaterialNumber',
                                    headerName: 'Broker Material',
                                    width: 170
                                },
                                { field: 'materialDescription', headerName: 'Description', width: 250 },
                                {
                                    field: 'orderedQuantity',
                                    headerName: 'Ordered',
                                    type: 'number',
                                    valueGetter: ({ row }) => row.orderedQuantity, // * row.unitPrice
                                },
                                { field: 'unitOfMeasure', headerName: 'UOM', width: 50, align: 'center' },
                                { field: 'incomingType', headerName: 'Inc. Type', width: 75 },
                                { field: 'materialGroup', headerName: 'Tray Size', width: 80, align: 'center', valueGetter: ({ row }) => row.materialGroup?.substring(3), },
                                {
                                    field: 'scheduledShipDate', headerName: 'Schedule Ship Date', width: 150, align:'center', valueFormatter: params => {
                                        let date = moment(params?.value);
                                        if (date.isValid()) {
                                            return moment(params?.value).format("MM/DD/YYYY")
                                        } return "";
                                    }

                                },
                                {
                                    field: 'submitted', headerName: 'Submitted', width: 125, type: 'boolean', renderCell: (params) => {
                                        return params.value ? (
                                            <CheckIcon
                                                style={{
                                                    color: 'green',
                                                }}
                                            />
                                        ) : (
                                            <CloseIcon
                                                style={{
                                                    color: 'green',
                                                }}
                                            />
                                        );
                                    },
                                },
                            ]}
                            rows={deliveryItems}
                            sx={{ flex: 1 }}
                            hideFooter
                        />
                    </Stack>
                </Paper>
            </Stack>
        );
    }

    const getDetailPanelHeight = React.useCallback(() => 400, []);

    const getDetailPanelContent = React.useCallback<
        NonNullable<DataGridProProps['getDetailPanelContent']>
    >(({ row }) => <DetailPanelContent row={row} />, []);

    return (<>
        <MTLButton
            variant="contained"
            color="primary"
            fullWidth={true}
            onClick={(event) => {
                event.stopPropagation();
                handleClickOpen();
            }}
        >View Orders</MTLButton>
        <Dialog fullWidth maxWidth={false}  open={open} onClose={handleClose}>
            <DialogTitle>View Deliveries</DialogTitle>
            <DialogContent>
                <DataGridPro
                    className={"DataGrid"}
                    style={{"width": "calc(100% - 2rem)", 'maxWidth': '100%', 'height': 'calc(100vh - 209px)', marginLeft: '0.5rem', marginRight: '0.5rem'}}
                    rows={cellValues.row.deliveryHeaders}
                    columns={columns}
                    rowsPerPageOptions={[5, 10]}
                    checkboxSelection={false}
                    disableSelectionOnClick
                    getDetailPanelContent={getDetailPanelContent}
                    getDetailPanelHeight={getDetailPanelHeight}
                />
            </DialogContent>
            <DialogActions>
                <Stack direction="row" spacing={2}>
                    <Button onClick={handleClose} text={"Close"}/>
                </Stack>
            </DialogActions>
        </Dialog>
    </>);
}